<template>
  <div>
    <div
      class="zalo-chat-widget"
      data-oaid="137117482624142109"
      data-welcome-message="Nhà hàng Món Việt hân hạnh phục vụ!"
      data-autopopup="0"
      data-width="300"
      data-height="300"
    ></div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
